import React, { useState, useRef } from 'react'
import useWindowDimension from '../../../hooks/useWindowDimension'

import ComponentTitle from '../../../components/ComponentTitle/ComponentTitle'
import Title from '../../../components/FeaturesAside/Title'
import Description from '../../../components/FeaturesAside/Description'

import LivenessCheckSvg from '../../../resources/images/transformedToSvg/livenes-age-new.svg'
import DocumentVerificationSvg from '../../../resources/images/transformedToSvg/doc-verification-new-1.svg'
import SophisticatedDashboard from '../../../resources/images/transformedToSvg/sophist-dashboard-new.svg'
import ESignatureSvg from '../../../resources/images/transformedToSvg/e-signature-new.svg'

import livenessIcon from '../../../resources/images/livenessIcon.svg'
import docIcon from '../../../resources/images/documentIcon.svg'
import sophisticatedIcon from '../../../resources/images/sophinsticatedIcon.svg'
import electronicIcon from '../../../resources/images/electronicIcon.svg'

import {
	StyledContainer,
	StyledTitleContainer,
	StyledMainContainer,
	StyledLeftContainer,
	StyledRightContainer,
	StyledUl,
	StyledLi,
	StyledLine,
	StyledIconContainer,
	StyledListTitleContainer,
	StyledMobileContainer
} from './kvaliFeaturesStyle'
import FeaturesMobile from '../../../components/FeaturesMobile/FeaturesMobile'

const imgs = {
	livenessAndCheckAge: <LivenessCheckSvg />,
	documentVerification: <DocumentVerificationSvg />,
	sophisticatedDashboard: <SophisticatedDashboard />,
	electronicSignatures: <ESignatureSvg />
}
const KvaliFeatures = () => {
	const { windowSize } = useWindowDimension()

	const [active, setActive] = useState('sophisticatedDashboard')
	const [animation, setAnimation] = useState(false)
	const timer = useRef()

	const onActiveChange = title => {
		if (title === active) {
			setActive('livenessAndCheckAge')
		} else {
			setActive(title)
		}
	}
	const handleAnimationChange = () => {
		if (animation) {
			clearTimeout(timer.current)
			timer.current = setTimeout(() => setAnimation(state => !state), 400)
			setAnimation(false)
			setAnimation(true)
		} else {
			timer.current = setTimeout(() => setAnimation(state => !state), 400)
			setAnimation(true)
		}
	}

	const showHideAnimation = title => {
		onActiveChange(title)
		handleAnimationChange()
	}

	const isLivenessAndCheckAge = active === 'livenessAndCheckAge'
	const isDocumentVerification = active === 'documentVerification'
	const isSophisticatedDashboard = active === 'sophisticatedDashboard'
	const isElectronicSignatures = active === 'electronicSignatures'

	return (
		<StyledContainer id='features'>
			<StyledTitleContainer>
				<ComponentTitle value='Features' />
			</StyledTitleContainer>
			{windowSize.width < 960 ? (
				<StyledMobileContainer>
					<FeaturesMobile
						title='kvaliFeatureAsideTitle1'
						description='kvaliFeatureAsideDesc1'
						image={<LivenessCheckSvg />}
					/>
					<FeaturesMobile
						title='kvaliFeatureAsideTitle2'
						description='kvaliFeatureAsideDesc2'
						image={<DocumentVerificationSvg />}
					/>
					<FeaturesMobile
						title='kvaliFeatureAsideTitle3'
						description='kvaliFeatureAsideDesc3'
						image={<SophisticatedDashboard />}
					/>
					<FeaturesMobile
						title='kvaliFeatureAsideTitle4'
						description='kvaliFeatureAsideDesc4'
						image={<ESignatureSvg />}
					/>
				</StyledMobileContainer>
			) : (
				<StyledMainContainer>
					<StyledRightContainer className={animation ? 'scale-up-center' : ''}>{imgs[active]}</StyledRightContainer>
					<StyledLeftContainer>
						<StyledUl>
							<StyledLi active={isLivenessAndCheckAge} onClick={() => showHideAnimation('livenessAndCheckAge')}>
								<StyledListTitleContainer>
									<StyledIconContainer>
										<img src={livenessIcon} alt='' />
									</StyledIconContainer>
									<Title value='kvaliFeatureAsideTitle1' />
								</StyledListTitleContainer>
								<Description value='kvaliFeatureAsideDesc1' to={'/liveness-and-age'} />
								{isLivenessAndCheckAge && <StyledLine />}
							</StyledLi>
							<StyledLi active={isDocumentVerification} onClick={() => showHideAnimation('documentVerification')}>
								<StyledListTitleContainer>
									<StyledIconContainer>
										<img src={docIcon} alt='' />
									</StyledIconContainer>
									<Title value='kvaliFeatureAsideTitle2' />
								</StyledListTitleContainer>
								<Description value='kvaliFeatureAsideDesc2' to={'/document-verification'} />
								{isDocumentVerification && <StyledLine />}
							</StyledLi>
							<StyledLi active={isElectronicSignatures} onClick={() => showHideAnimation('electronicSignatures')}>
								<StyledListTitleContainer>
									<StyledIconContainer>
										<img src={electronicIcon} alt='' />
									</StyledIconContainer>
									<Title value='kvaliFeatureAsideTitle4' />
								</StyledListTitleContainer>
								<Description value='kvaliFeatureAsideDesc4' to={'/electronic-signature'} />
								{isElectronicSignatures && <StyledLine />}
							</StyledLi>
							<StyledLi
								active={isSophisticatedDashboard}
								onClick={() => showHideAnimation('sophisticatedDashboard')}
							>
								<StyledListTitleContainer>
									<StyledIconContainer>
										<img src={sophisticatedIcon} alt='' />
									</StyledIconContainer>
									<Title value='kvaliFeatureAsideTitle3' />
								</StyledListTitleContainer>
								<Description value='kvaliFeatureAsideDesc3' hideReadMore />
								{isSophisticatedDashboard && <StyledLine />}
							</StyledLi>
						</StyledUl>
					</StyledLeftContainer>
				</StyledMainContainer>
			)}
		</StyledContainer>
	)
}

export default KvaliFeatures
